
import { defineComponent } from '@nuxtjs/composition-api';
import type { PropOptions } from 'vue';
import { mapActions } from 'vuex';
import WarRoomVoteButton from '@/components/partials/war-room/WarRoomVote/WarRoomVoteButton.vue';
import ArrowIcon from '@/components/partials/war-room/WarRoomVote/images/arrow.vue.svg';
import warRoomSignUpMixin from '@/components/partials/war-room/WarRoomSignUp/warRoomSignUpMixin';
import { votableTypes } from '@/components/partials/war-room/constants';
import type { IPost } from '@/types/community';

export default defineComponent({
  name: 'WarRoomPostVote',
  components: {
    ArrowIcon,
    WarRoomVoteButton,
  },
  mixins: [warRoomSignUpMixin],
  props: {
    post: {
      type: Object,
      required: true,
    } as PropOptions<IPost>,
  },
  computed: {
    arrowIconClassesDownvoted() {
      return {
        'war-room-post-vote__icon': true,
        'war-room-post-vote__icon--reversed': true,
      };
    },
    isUpvoted() {
      return this.post?.current_vote === 1;
    },
    isDownvoted() {
      return this.post?.current_vote === -1;
    },
    counterClasses() {
      return {
        'war-room-post-vote__count': true,
        'war-room-post-vote__count--upvoted': this.isUpvoted,
        'war-room-post-vote__count--downvoted': this.isDownvoted,
      };
    },
  },
  methods: {
    ...mapActions('warRoom', ['addVote', 'removeVote']),
    handleUpVote() {
      if (this.$auth.loggedIn) {
        if (this.isUpvoted) {
          this.handleRemoveVote();
        } else {
          this.handleAddVote(1);
        }
      } else {
        this.openWarRoomSignUpModal();
      }
    },
    handleDownVote() {
      if (this.$auth.loggedIn) {
        if (this.isDownvoted) {
          this.handleRemoveVote();
        } else {
          this.handleAddVote(-1);
        }
      } else {
        this.openWarRoomSignUpModal();
      }
    },
    handleAddVote(value: number) {
      this.$analytics.logEvent(`war-room__post__rating__set`, { value });
      this.addVote({ votable: this.post, type: votableTypes.POST, value });
    },
    handleRemoveVote() {
      this.$analytics.logEvent(`war-room__post__rating__unset`);
      this.removeVote({ votable: this.post, type: votableTypes.POST });
    },
  },
});
